<template>
  <div class="">
    <div class="content">
      <div v-if="video" class="single">
        <Video></Video>
      </div>
      <div v-else>
        <div class="meta">
          <div class="filter">
            <v-text-field
              v-model="search"
              append-icon="search"
              :label="$t('admin.views.videos.filter')"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <div class="buttons">
            <v-btn v-if="!video" outline @click="add" color="success"
              >{{ $t('admin.views.videos.create') }}</v-btn
            >
          </div>
        </div>
        <v-data-table
          :custom-filter="filter"
          :headers="headers"
          :items="videos"
          class="elevation-1"
          :no-results-text="message_not_found"
          :rows-per-page-items="pagination"
          :search="search"
          :rows-per-page-text="message_rows_per_page"
        >
          <template v-slot:items="props">
            <td>{{ props.item.url }}</td>
            <td>{{ props.item.start_date | moment }}</td>
            <td>{{ props.item.end_date | moment }}</td>
            <td>
              <img
                class="image2"
                v-if="props.item.status == 1"
                src="/img/success.svg"
              /><img class="image2" v-else src="/img/error.svg" />
            </td>
            <td>
              <v-icon @click="edit(props.item)">edit</v-icon
              ><v-icon @click="remove(props.item)">delete</v-icon>
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Video from "@/components/domain/admin/Video";

export default {
  name: "Videos",
  props: { page: String },
  components: { Video },
  data() {
    return {
      headers: [
        { text: i18n.t('general.url'), value: "url" },
        { text: i18n.t('general.headers.start_date'), value: "start_date" },
        { text: i18n.t('general.headers.end_date'), value: "end_date" },
        { text: i18n.t('general.active'), value: "status", width: "50px", align: "left" },
        { text: "", value: "actions" }
      ],
      search: "",
      id: -1,
      message_not_found: i18n.t('admin.views.videos.message_not_found'),
      message_rows_per_page: i18n.t('admin.views.videos.message_rows_per_page'),
      pagination: [10, 20, 30, { text: i18n.t('general.all'), value: -1 }],
      add_video: {
        id: -1,
        url: "",
        start_date: null,
        end_date: null,
        status: 1
      }
    };
  },
  computed: {
    videos() {
      return Object.values(this.$store.getters["sliders/getAllVideoAdv"]);
    },

    video() {
      return this.$store.getters["sliders/getCurrentVideo"];
    }
  },
  filters: {
    moment: function(date) {
      if (date == null) return "-";
      return moment(date).format("DD/MM/YYYY");
    }
  },
  methods: {
    edit(video) {
      this.$store.commit("sliders/setCurrentVideo", video);
    },

    remove(video) {
      var self = this;
      this.$popup.confirm(
        i18n.t('admin.views.videos.popup.delete'),
        i18n.t('admin.views.videos.popup.delete_message'),
        i18n.t('general.accept'),
        i18n.t('general.cancel'),
        function() {
          self.$store.dispatch("sliders/removeVideoAdv", video.id);
        }
      );
    },
    add() {
      this.$store.commit("sliders/setCurrentVideo", this.add_video);
    },
    filter(items, search, filter) {
      var aItems = [];
      items.forEach(item => {
        if (filter(item.url, search.toLowerCase())) {
          aItems.push(item);
        }
      });
      return aItems;
    }
    // sort(items, search, filter) {
    //   items.sort(function(a, b) {
    //     if (a.priority < b.priority) return -1;
    //     return 1;
    //   });

    //   return items;
    // }
  },
  watch: {
    // call again the method if the route changes
    // '$route': 'loadDataPage'
  },
  created() {
    this.$store.commit("setTitle", i18n.t('admin.views.videos.name'));
    this.$store.commit("setMenuVisible", false);

    if (
      Object.keys(this.$store.getters["sliders/getAllVideoAdv"]).length == 0
    ) {
      var self = this;

      this.$store
        .dispatch("sliders/loadAllVideosAdv", this.$route.params.id)
        .then(function() {
          switch (self.page) {
            case "edit":
              self.$store.commit(
                "sliders/setCurrentVideoByID",
                self.$route.params.id
              );
              break;
            case "add":
              self.$store.commit("sliders/setCurrentVideo", self.add_video);
              break;
            default:
              break;
          }
        });
    } else {
      switch (this.page) {
        case "edit":
          this.$store.commit(
            "sliders/setCurrentVideoByID",
            this.$route.params.id
          );
          break;
        case "add":
          this.$store.commit("sliders/setCurrentVideo", this.add_video);
          break;
        default:
          break;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.sidebar-cnt {
  width: 300px;
  display: inline-block;
  float: left;
}
.content {
  width: 100%;
  display: inline-block;
  float: left;
  padding: 20px 40px 50px;
  position: relative;

  .meta {
    margin-bottom: 25px;
    overflow: hidden;

    .filter {
      float: left;
      width: 400px;
    }
    .buttons {
      float: right;
    }
  }

  .image {
    width: 100%;
  }
  .image2 {
    width: 50%;
  }

  .header {
    width: 100%;
    text-align: left;
    margin-bottom: 15px;
    overflow: hidden;

    .meta {
      float: left;
      width: 70%;

      .breadcrumbs {
        color: #aaa;
        display: block;
        width: 100%;

        .cat1 {
          display: inline-block;
          font-weight: bold;
          font-family: Speedee-Bold;
        }
        .cat2 {
          display: inline-block;

          &:before {
            content: "|";
            margin: 0 5px;
          }
        }
      }
      .title {
        background: var(--main_color);
        color: var(--dark_color);
        width: auto;
        display: inline-block;
        text-align: left;
        float: left;
        font-size: 25pt;
        font-family: Speedee-Bold;
        padding: 0 5px;
        margin: 0;
        margin-top: 5px;
        line-height: 25pt;
        padding-bottom: 5px;
      }
    }

    .filter {
      float: left;
      width: 30%;
      text-align: right;
      padding: 0 10px;

      .search {
        display: block;
        overflow: hidden;
        margin-top: 5px;
        -webkit-transition: all 1s;
        transition: all 1s;

        .input {
          border: none;
          border-bottom: 2px solid #ccc;
          padding: 5px;
          outline: none;
          background: url("/img/magnify.svg") no-repeat right 5px center;
          background-size: 20px;
          width: 100%;
          float: left;
        }
        .icon {
          display: none;
          cursor: pointer;
          width: 30px;
          height: 30px;
          background: url("/img/go.svg") no-repeat center var(--main_color);
          background-size: 20px;
          border-radius: 3px;
        }
        &.active {
          .input {
            width: calc(100% - 40px);
            background: transparent;
          }
          .icon {
            display: inline-block;
          }
        }
      }
    }
  }
}

/* Sort hide arrows */
.elevation-1 .v-table tbody tr:first-child td {
  .up {
    display: none;
  }
}

.elevation-1 .v-table tbody tr:last-child td {
  .down {
    display: none;
  }
}
</style>
